/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Upload } from './Upload';
import {
    UploadFromJSON,
    UploadFromJSONTyped,
    UploadToJSON,
    UploadToJSONTyped,
} from './Upload';

/**
 * 
 * @export
 * @interface DocumentVersion
 */
export interface DocumentVersion {
    /**
     * 
     * @type {number}
     * @memberof DocumentVersion
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof DocumentVersion
     */
    companyId: number;
    /**
     * 
     * @type {number}
     * @memberof DocumentVersion
     */
    documentId: number;
    /**
     * The ID of the employee who uploaded this version
     * @type {number}
     * @memberof DocumentVersion
     */
    uploaderId: number | null;
    /**
     * The ID of the Upload entity
     * @type {number}
     * @memberof DocumentVersion
     */
    uploadId: number | null;
    /**
     * The version number of this document version
     * @type {number}
     * @memberof DocumentVersion
     */
    version: number;
    /**
     * Whether this version had to be accepted, recorded when a newer version replaced it. Null for the latest version, which still follows the document.
     * @type {boolean}
     * @memberof DocumentVersion
     */
    acceptanceRequired: boolean | null;
    /**
     * The employees this version went out to, recorded when a newer version replaced it. Empty for the latest version, which is still shared with whoever the document is shared with.
     * @type {Array<number>}
     * @memberof DocumentVersion
     */
    audienceEmployeeIds: Array<number>;
    /**
     * 
     * @type {Upload}
     * @memberof DocumentVersion
     */
    upload: Upload;
    /**
     * 
     * @type {Date}
     * @memberof DocumentVersion
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof DocumentVersion
     */
    updatedAt: Date | null;
}

/**
 * Check if a given object implements the DocumentVersion interface.
 */
export function instanceOfDocumentVersion(value: object): value is DocumentVersion {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('documentId' in value) || value['documentId'] === undefined) return false;
    if (!('uploaderId' in value) || value['uploaderId'] === undefined) return false;
    if (!('uploadId' in value) || value['uploadId'] === undefined) return false;
    if (!('version' in value) || value['version'] === undefined) return false;
    if (!('acceptanceRequired' in value) || value['acceptanceRequired'] === undefined) return false;
    if (!('audienceEmployeeIds' in value) || value['audienceEmployeeIds'] === undefined) return false;
    if (!('upload' in value) || value['upload'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function DocumentVersionFromJSON(json: any): DocumentVersion {
    return DocumentVersionFromJSONTyped(json, false);
}

export function DocumentVersionFromJSONTyped(json: any, ignoreDiscriminator: boolean): DocumentVersion {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'companyId': json['companyId'],
        'documentId': json['documentId'],
        'uploaderId': json['uploaderId'],
        'uploadId': json['uploadId'],
        'version': json['version'],
        'acceptanceRequired': json['acceptanceRequired'],
        'audienceEmployeeIds': json['audienceEmployeeIds'],
        'upload': UploadFromJSON(json['upload']),
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (json['updatedAt'] == null ? null : new Date(json['updatedAt'])),
    };
}

  export function DocumentVersionToJSON(json: any): DocumentVersion {
      return DocumentVersionToJSONTyped(json, false);
  }

  export function DocumentVersionToJSONTyped(value?: DocumentVersion | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'companyId': value['companyId'],
        'documentId': value['documentId'],
        'uploaderId': value['uploaderId'],
        'uploadId': value['uploadId'],
        'version': value['version'],
        'acceptanceRequired': value['acceptanceRequired'],
        'audienceEmployeeIds': value['audienceEmployeeIds'],
        'upload': UploadToJSON(value['upload']),
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': (value['updatedAt'] == null ? null : (value['updatedAt'] as any).toISOString()),
    };
}

